var map = {
	"./1.jpg": 9373,
	"./2.jpg": 418,
	"./3.jpg": 6799,
	"./4.jpg": 4068,
	"./5.jpg": 2113,
	"./6.jpg": 2502,
	"./7.jpg": 4115,
	"./mainImg.jpg": 5856
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9471;